import { checkIsEmptyHtmlString } from "./common/validators/validators";

/**
 * @function evaluates the value which can be previewed from CT.
 * @param {string} value - The HTML/simple string to check.
 * @param {boolean} isPreview - whether it is preview mode(manage webpage or sales page builder in CT) or not
 * @param {string} dummyString - dummy string to be used if `value` is empty and it is preview mode
 * @returns
 */
export const getPreviewableValue = ({
    value = "",
    dummyString,
    isPreview,
}: {
    value: string;
    dummyString: string;
    isPreview: boolean;
}) => {
    if (checkIsEmptyHtmlString(value)) {
        return isPreview ? dummyString : "";
    }
    return value;
};

/**
 * @function To ensure no unwanted frame can access the preview mode postMessage capabilities
 * @param {string} origin - MessageEvent.origin specifying the origin of the postMessage browser API
 * @returns returns true for valid sources(webpage, sales page builder in CT) and false for invalid Sources
 */
export function checkIsValidPreviewOrigin(origin: string) {
    const validSources = `${
        process.env.NEXT_PUBLIC_PREVIEW_URL ||
        process.env.NEXT_PUBLIC_PROJECT_DOMAIN ||
        ""
    }`
        .split(",")
        .filter(Boolean)
        .map(p => p.trim());

    return origin && (validSources || []).includes(origin);
}
